import { generateTraceId } from './ids';
import { SentryTrace } from './sentrytrace';

/**
 * Tracing implemention for the browser.
 */
export class Trace extends SentryTrace() {
    /**
     * Return the current current root trace.
     */
    public static getCurrentRootTrace(): Trace | null {
        return null;
    }

    /**
     * Get the context (root trace and parent span) of the current trace.
     */
    public getParentContext(): {
        traceId: string;
        parentSpanId: string | null;
        traceFlags: number;
    } {
        return {
            traceId: generateTraceId(),
            parentSpanId: null,
            traceFlags: 0x01,
        };
    }

    /**
     * Name of the measure to use in the dev tools.
     */
    private get measureName(): string {
        const keys = Object.keys(this.labels);
        keys.sort();
        const args = keys.map((k) => `${k}: ${JSON.stringify(this.labels[k])}`).join(', ');
        return `${this.name}(${args})`;
    }

    protected start() {
        super.start();

        if (window?.performance?.mark) {
            window.performance.mark(`trace:${this.spanId}:start`);
        }
    }

    protected end(error: Error | null) {
        super.end(error);

        // Ensure mark / measure are defined: https://bugs.webkit.org/show_bug.cgi?id=137407
        if (window?.performance?.mark && window.performance.measure) {
            window.performance.mark(`trace:${this.spanId}:end`);
            try {
                window.performance.measure(
                    this.measureName,
                    `trace:${this.spanId}:start`,
                    `trace:${this.spanId}:end`
                );
            } catch (e) {
                // It can happen that the start trace cannot be found.
                // https://sentry.io/organizations/gitbook-x/issues/3034374841/events/40a0e59134b644308f6dda718c7ca6e3/?project=5960429
                // Ignore errors as this is not critical, but log a warning when this happens.
                this.logger.warning(`Error while measuring trace ${this.spanId}`, e);
            }
        }
    }
}
